import HttpCliente from "../HttpCliente";

export const getEstadoTramitacion = (token) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get("/EstadoTramitacion/ObtenerEstadosTramitaciones", {
      headers: {
        Authorization: `Bearer ${token}`,
        accept: "text/plain",
      },
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const postEstadoTramitacion = (token, estado) => {
  return new Promise((resolve, reject) => {
    HttpCliente.post("/EstadoTramitacion/Crear", estado, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const putEstadoTramitacion = (token, estado) => {
  return new Promise((resolve, reject) => {
    HttpCliente.put("/EstadoTramitacion/EditarEstadoTramitacion", estado, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteEstadoTramitacion = (token, id) => {
  return new Promise((resolve, reject) => {
    HttpCliente.delete(`/EstadoTramitacion/Deshabilitar/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        accept: "text/plain",
      },
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getEstadoTramitacionHabilitado = (token) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get("/EstadoTramitacion/ObtenerEstadoTramitacionHabilitado", {
      headers: {
        Authorization: `Bearer ${token}`,
        accept: "text/plain",
      },
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
